import React, { FunctionComponent } from 'react'

import { BodyText } from '../../atoms/bodyText/BodyText'
import { Link } from '../../atoms/link/Link'
import { tID } from '../../utils/utils'

type ClientIntakeCancellationPolicyTextProps = {
  navigateToCancellationPolicyFAQ: () => void
  policyText: string
}

// Read-only version of the cancellation policy so the hook that generate the text does not have to be run when viewing a
// submitted Client Intake
export const ClientIntakeCancellationPolicyText: FunctionComponent<ClientIntakeCancellationPolicyTextProps> = ({
  policyText,
  navigateToCancellationPolicyFAQ,
}) => {
  // These strings are deliberately not translated as they are part of the Client Intake form
  const policyLinkPrefix = 'I agree to the '
  const policyLinkText = 'cancellation policy'
  const policyLinkSuffix = `. ${policyText}`

  return (
    <>
      <BodyText text={policyLinkPrefix} />
      <Link
        text={policyLinkText}
        onPress={navigateToCancellationPolicyFAQ}
        testID={tID('ClientIntake-cancellation-consent-faq-link')}
        accessibilityLabel='Learn more about the cancellation policy (opens FAQ)'
        underline
      />
      <BodyText text={policyLinkSuffix} testID={tID('ClientIntake-cancellation-consent-text')} />
    </>
  )
}
